import { useAsync } from 'react-use';
import { head } from 'lodash';
import { ComponentContainer } from '@styles/layout';
import { GenericComponent } from '@model/content';
import { Country, Region } from '@model/common';
import { ContentApi } from '@model/iceberg/service/content';
import { ExploreResorts } from '@components/explore-resorts';
import { getDestinationResorts } from '@util/destination';

export const ResortsListContainer = ({ path, data }: GenericComponent) => {
  if (!path) {
    return null;
  }

  const { value } = useAsync(async () => {
    const retVal = data ? data : await new ContentApi().getDestination(path);
    return retVal;
  }, [path]);

  const destination: Country | Region | undefined = head(value);

  if (!destination) {
    return null;
  }

  const resorts = getDestinationResorts(destination);
  const mappedResorts = resorts.map(({ holidays, display, path }) => ({
    name: {
      display,
      path
    },
    hotels: holidays.length
  }));

  return (
    <ComponentContainer>
      <ExploreResorts title={destination.display} path={path} resorts={mappedResorts} />
    </ComponentContainer>
  );
};
